// Generated by `pnpm gen:svg` from src/assets/svg — do not edit.
import type { SVGProps } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  ref?: Ref<SVGSVGElement>;
}
const SvgAbraFlexi = ({
  title,
  titleId,
  ref,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 200 200"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <defs>
      <linearGradient
        id="abra-flexi-gradient"
        x1={40.9970776}
        y1={3.8241132}
        x2={65.0095226}
        y2={45.7583701}
        gradientTransform="translate(-.2859651 2.6827717) rotate(.06)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.15} stopColor="#e8496a" />
        <stop offset={1} stopColor="#f7a82c" />
      </linearGradient>
    </defs>
    <g transform="translate(20 53.4) scale(2.161)">
      <path
        fill="#414453"
        fillRule="evenodd"
        d="M24.6599998,0L0,43.1600037h24.6199989L49.2700005.0200043S24.6599998.0000038,24.6599998,0Z"
      />
      <path
        fill="url(#abra-flexi-gradient)"
        fillRule="evenodd"
        d="M50.0200005,1.2299995l24.0199966,41.9300041h-24.8399963l-11.4499969-20.4400024L50.0300026,1.2300034l-.0100021-.0000038Z"
      />
    </g>
  </svg>
);
export { SvgAbraFlexi };
